<div class="tenant-services">
  <a href="javascript:void(0)" class="back-link" (click)="goBack()">
    <i class="bi bi-chevron-left"></i> Back to Overview
  </a>

  <div class="d-flex justify-content-between align-items-start mb-3">
    <div>
      <h2 class="page-title">Services</h2>
      <p class="page-subtitle">Manage services and database credentials</p>
    </div>
    <button type="button" class="btn add-credential-btn" (click)="openAdd()">
      <i class="bi bi-plus-lg"></i> Add Services
    </button>
  </div>

  @if (loading) {
    <div class="loading-container">
      <app-loader />
    </div>
  } @else {
    <app-table
      [columns]="columns"
      [data]="rows"
      [actions]="actions"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)"
      (columnAction)="onColumnAction($event)"
    />
  }

  @if (modalOpen) {
    <app-tenant-services-modal
      [mode]="modalMode"
      [tenantUid]="tenantUid"
      [service]="selectedService"
      (closed)="onModalClosed()"
      (saved)="onModalSaved()"
    />
  }

  @if (dbModalOpen) {
    <app-tenant-service-db
      [tenantUid]="tenantUid"
      [preloadedConfig]="dbConfigResponse"
      (closed)="onDbModalClosed()"
      (saved)="onDbModalSaved()"
    />
  }

  @if (mdmModalOpen) {
    <app-tenant-service-mdm-db-config
      [tenantUid]="tenantUid"
      [preloadedConfig]="mdmConfigResponse"
      (closed)="onMdmModalClosed()"
      (saved)="onMdmModalSaved()"
    />
  }
</div>
